import React from "react";
import { toastr } from "react-redux-toastr";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";

import { create } from "../../../utils/apiService";

import { updateVideo } from "../../../actions";

import SetDateModal from "../../modals/SetDateModal";
import moment from "moment";

class MailingGenerateUrlButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showExpirationDateModal: false,
      expirationDate: ""
    };

    this.generateURL = this.generateURL.bind(this);

    // Expiration Date Modal
    this.openExpirationDateModal = this.openExpirationDateModal.bind(this);
    this.closeExpirationDateModal = this.closeExpirationDateModal.bind(this);
    this.closeExpirationDateModalAndGenereteURL = this.closeExpirationDateModalAndGenereteURL.bind(this);
  }

  openExpirationDateModal() {
    this.setState({ showExpirationDateModal: true });
  }
  closeExpirationDateModal() {
    this.setState({ showExpirationDateModal: false });
  }
  closeExpirationDateModalAndGenereteURL(date) {
    this.setState(
      {
        showExpirationDateModal: false,
        expirationDate: date
      },
      () => {
        this.generateURL();
      }
    );
  }

  async generateURL() {
    toastr.info("Gerando URLs...");
    const { mailing, video, updateVideo } = this.props;
    let ISODate = moment(this.state.expirationDate).format("YYYY-MM-DD");

    let url = `/campaigns/${video.campaign_id}/videos/${video.id}/sendings`;
    let data = {
      data_path: mailing.data_path,
      mailing_id: mailing.id,
      expiration_date: ISODate
    };
    try {
      let response = await create(url, data);
      let updatedVideo = response.data;
      updateVideo(updatedVideo.campaign_id, updatedVideo);
      toastr.success("URL sendo geradas!");
    } catch (err) {
      toastr.error("Erro ao iniciar geração de URLs");
    }
  }
  render() {
    const { mailing } = this.props;

    return (
      <div>
        {mailing.status === "Aprovado" && (
          <div>
            <Button
              bsStyle="link"
              bsSize="xsmall"
              onClick={() => {
                // this.generateURL(mailing);
                this.openExpirationDateModal();
              }}
            >
              Gerar URLs
            </Button>

            <SetDateModal
              show={this.state.showExpirationDateModal}
              cancel={this.closeExpirationDateModal}
              success={this.closeExpirationDateModalAndGenereteURL}
              date={this.state.expirationDate}
              label="data de expiração"
            />
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  updateVideo: (campaignId, video) => {
    dispatch(updateVideo(campaignId, video));
  }
});

export default connect(null, mapDispatchToProps)(MailingGenerateUrlButton);



// WEBPACK FOOTER //
// ./src/components/pages/Mailing/MailingGenerateUrlButton.js